// extracted by mini-css-extract-plugin
export default {"hybridTable":"steRUygf2lEoSaeieDMw","column":"N_i7sbUohc_zHdD5eYoA","actionColumn":"uxreIMd8YFkDKSYBTfs6"};